import {GROUP_ADMIN} from 'groups-common/src/lib/group-member-permission-types';

export const getCurrentGroup = state => state.currentGroup;
export const getGroupId = state => getCurrentGroup(state).groupId;
export const getGroupName = state => getCurrentGroup(state).details.title;
export const getGroupRelationship = state => getCurrentGroup(state).relationship;
export const getPrivacyLevel = state => getCurrentGroup(state).settings.privacyLevel;
export const getCoverImage = state => getCurrentGroup(state).details.imageUrl;
export const getImage = state => getCurrentGroup(state).details.logoUrl;
export const getMembersCount = state => getCurrentGroup(state).memberCount;
export const getIsGroupAdmin = state => getCurrentGroup(state).roles.includes(GROUP_ADMIN);
